const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'invitations',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.invitations" */ '@/views/Invitations'),
  },
  meta: {
    breadcrumb: {
      label: 'Invitations',
    },
  },
  children: [
    {
      path: '',
      name: 'invitations-listing',
      component: () => import(/* webpackChunkName: "module.invitations.list" */ '@/modules/Invitations/List'),
      meta: {
        breadcrumb: {
          label: 'Invitations',
        },
      },
    },
    {
      path: ':id/edit',
      name: 'invitations-edit',
      component: () => import(/* webpackChunkName: "module.invitations.edition" */ '@/modules/Invitations/Edition'),
      meta: {
        breadcrumb: {
          parent: 'invitations-listing',
          label: 'Edit Invitation',
        },
      },
    },
    {
      path: 'create',
      name: 'invitations-create',
      component: () => import(/* webpackChunkName: "module.invitations.edition" */ '@/modules/Invitations/Edition'),
      meta: {
        breadcrumb: {
          parent: 'invitations-listing',
          label: 'Create Invitation',
        },
      },
    },
    {
      path: 'create-bulk',
      name: 'invitations-create-bulk',
      component: () => import(/* webpackChunkName: "module.invitations.bulk" */ '@/modules/Invitations/Bulk'),
      meta: {
        breadcrumb: {
          parent: 'invitations-listing',
          label: 'Create Bulk Invitation',
        },
      },
    },
  ],
};
